/*
Copyright 2024 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0
Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

let themeTitleInput = document.getElementById('themeNameInput');
let themeTitleTextField = document.getElementById('themeNameTextfield');

function handleKeyUp(event) {
  //key code for enter
  if (event.keyCode === 13) {
    event.preventDefault();
    event.target.blur();
    themeTitleTextField.classList.add('spectrum-Textfield--custom');
    let characters = themeTitleInput.value.length;
    themeTitleInput.style.width = `${characters + 4}ch`;
  }
}

themeTitleInput.addEventListener('focus', () => {
  themeTitleTextField.classList.remove('spectrum-Textfield--custom');
  themeTitleInput.style.width = `200px`;
});
themeTitleInput.addEventListener('blur', () => {
  themeTitleTextField.classList.add('spectrum-Textfield--custom');
  let characters = themeTitleInput.value.length;
  themeTitleInput.style.width = `${characters + 4}ch`;
});

themeTitleInput.addEventListener('keydown', (e) => {
  handleKeyUp(e);
});
